<p>user-special-permission works!</p>
